import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class ProductsService {
  searchProducts = (params) => {
    return fetch(config.config.endpointUrls.searchProducts(), {
      method: 'POST',
      body: params
    })
  }
  fetchProduct = (params) => {
    return fetch(config.config.endpointUrls.fetchProduct(params), {
      method: 'GET'
    })
  }
  fetchProductGroupProducts = (params) => {
    return fetch(config.config.endpointUrls.fetchProductGroupProducts(params), {
      method: 'GET'
    })
  }

  fetchProductByEan = params => {
    return fetch(config.config.endpointUrls.fetchProductByEan(params), {
      method: 'GET'
    })
  }

  fetchProductCatalogues = params => {
    return fetch(config.config.endpointUrls.fetchProductCatalogues(params), {
      method: 'GET'
    })
  }
}

export default new ProductsService()



// WEBPACK FOOTER //
// ../src/services/productsService/productsService.js